import ListaMaquinasGelo from "./ListaMaquinaGelo";
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
export default function MaquinaGeloForm() {
    return (
        <AlertDialogOnClose nome={"Máquina de Gelo"} placeholder={"Insira o nome da máquina"}>
            <ListaMaquinasGelo />
        </AlertDialogOnClose>
    )
} 